// España
export default {
	title: "Nivel VIP",
	current: "Nivel VIP actual",
	status: {
		btn: ["Ya registrado", "Regístrate ahora mismo"]
	}
};
